<template>
    <div class="w-100">
        <form>
            <div class="form-group my-0 mb-3">
                <label class="fw-500 fs-14">{{ multiselectLabel }}</label>
                <div class="position-relative">
                    <Multiselect 
                        :id="'deal-' + type + '-reason-select'" 
                        track-by="label"
                        label="label"
                        v-model="reason" 
                        :class="{ 'is-invalid': errors.find(error => error.field === 'reason') }"
                        :options="reasonsOptions"
                        :multiple="multiselect.multiple" 
                        :searchable="multiselect.searchable"
                        :show-labels="multiselect.showLabel" 
                        :hide-selected="multiselect.hideSelected"
                        :preserve-search="multiselect.preserveSearch" 
                        :placeholder="multiselectPlaceholder"
                        :no-result="multiselect.noResult" 
                        :group-select="multiselect.groupSelect"
                        :internal-search="multiselect.internalSearch" 
                        @select="selectReason"
                        @search-change="searchReason"
                    >
                        <template slot="noResult">{{ __('Nenhum resultado encontrado') }}</template>
                        <template slot="noOptions">{{ __('Nenhum resultado encontrado') }}</template>
                    </Multiselect>
                    <span class="search-icon-origin">
                        <img
                            src="/build/icons/search-icon.svg"
                            width="16"
                            height="16"
                            alt="Lupa do campo de pesquisa"
                            class="position-absolute filter-user-icon"
                        />
                    </span>
                </div>
                <span v-if="errors.find(error => error.field === 'reason')" class="text-danger d-block mt-1">{{ __(`*Você deve informar o motivo de ${__(type)}`) }}</span>
            </div>
            <div class="form-group my-0 py-0">
                <label class="fw-500 fs-14" for="observation">{{ __('Observações') }}</label>
                <textarea 
                    style="resize: none;" 
                    rows="4" 
                    :placeholder="__('Registre aqui suas observações...')"
                    type="text" 
                    class="form-control py-2 textarea" 
                    :class="{ 'is-invalid': errors.find(error => error.field === 'observation') }"
                    id="observation" 
                    v-model="observation" 
                    required
                    maxlength="100"
                ></textarea>
                <span v-if="errors.find(error => error.field === 'observation')" class="text-danger d-block mt-1"> {{ errors.find(error => error.field === 'observation').error }}</span>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    name: 'ActionsReasonForm',
    data() {
        return {
            errors: [],
            localDealId: null, // Propriedade local para dealId
            multiselect: {
                multiple: false,
                showLabel: false,
                noResult: 'Nenhuma opção encontrada',
                groupSelect: false,
                searchable: true,
            },
            observation: '',
            reason: [],
            reasonsOptions: [],
            searching: false
        }
    },

    props: {
        type: {
            type: String,
            required: true
        },
        multiselectLabel: {
            type: String,
            required: true
        },
        multiselectPlaceholder: {
            type: String,
            required: true
        }
    },

    methods: {
        dealTypeDTO(type) {
            return {
                lost: 'deal.lost',
                won: 'deal.closed'
            }[type]
        },

        typeToAPIDTO(type) {
            return {
                lost: 'lost',
                won: 'closed'
            }[type]
        },

        resetForm() {
            this.reason = []
            this.observation = '';
            this.errors = [];
        },

        retrieveReasons(reasons) {
            this.reasonsOptions = reasons.map((reason) => {
                return {
                    value: reason.id,
                    label: reason.name
                }
            })
        },
        
        async saveDealLostReason(card) {
            this.errors = [];

            if (this.reason.label == '' || this.reason.value == '' || this.reason.length === 0) {
                this.errors.push(
                    {
                        error: '*Você informar o motivo de ' + this.type,
                        field: 'reason'
                    });
            } 
            
            
            if (this.observation.length > 100) {
                this.errors.push(
                    {
                        error: '*Limite de caracteres excedido',
                        field: 'observation'
                    });
            }
            
            if (this.errors.length > 0) {
                return;
            }

         
            this.updateDealReason(card.id).then(() => {
                this.resetForm();
                Bus.$emit('closeDealActionModal', true);
                Bus.$emit('askShouldCreateAnotherDeal', card);

            });
        },

        async searchReason(reason) {
            this.searching = true;

            if (reason.length < 3 && reason != '') {
                return;
            }

            this.$http.get(`/settings/status?type=${this.dealTypeDTO(this.type)}&q=${reason}`)
                .then((response) => {
                    this.retrieveReasons(response.data)
                })
                .finally(() => {
                    this.searching = false;
                });
        },

        selectReason(reason) {
            this.reason = reason
        },

        async updateDealReason(cardId) {
            this.$http.put(`/deal/${cardId}`, {
                status: this.typeToAPIDTO(this.type),
                reason_id: this.reason.value,
                observation: this.observation
            })
            .then(() => {})
            .catch(() => Bus.$emit('reinsertDeal'))
        },
    },

    mounted() {        
        Bus.$on('updateDealReason', (card) => this.saveDealLostReason(card));
        Bus.$on('resetForm', () => this.resetForm());
        this.searchReason('')
    }
}
</script>

<style lang="scss" scoped>

    // General
    .is-invalid {
        border: 1px solid #dc3545 !important;
    }

    .fs-14 {
        font-size: 14px !important;
    }

    /* Multiselect */
    .multiselect {
        border: 1px solid #D1D1D1;
        border-radius: 0.5rem;
        box-sizing: content-box;
        display: block;
        position: relative;
        width: 100%;
        min-height: 40px;
        text-align: left;
        color: #35495e;
    }

    ::v-deep .multiselect__placeholder {
        color: #adadad;
        display: inline-block;
        margin-bottom: 10px;
        padding: 16px 20px;
        font-size: 12px;
        border: 0px solid #fff;
        border-radius: 1rem;
    }
   
    ::v-deep .multiselect__input {
        border-radius: 1rem !important;
        padding: 0px 20px;
        color: #857A98;
        font-size: 12px;
        position: relative;
        display: inline-block;
        min-height: 20px;
        line-height: 20px;
        border: none;
        background: #fff;
        padding: 0 0 0 1rem;
        width: 100%;
        transition: border 0.1s ease;
        box-sizing: border-box;
        margin-bottom: 8px;
        vertical-align: top;
    }

    .multiselect__tags {
        max-height: none;
        background-color: transparent !important;
        padding: 0px !important;
    }

    ::v-deep .multiselect__single {
        border: 0px solid #fff;
        border-radius: 1rem;
        padding: 16px 20px;
        padding-right: 32px;
        color: #242424;
        font-family: Montserrat, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif;
        margin-bottom: 8px;
        font-size: 12px !important;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    /* Search icon */
    .search-icon-origin {
        position: absolute;
        top: 18px;
        right: 28px;
        z-index: 5;
    }

    .fw-500 {
        font-weight: 500;
    }

    /* textarea */
    .textarea {
        display: block;
        width: 100%;
        padding: 0.5rem 1rem;
        font-family: Montserrat, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif;
        font-size: 0.75rem;
        font-weight: 400;
        line-height: 1.5;
        color: #3B334A;
        background-color: #fff;
        background-clip: padding-box;
        border: 0 solid #ced4da;
        border-radius: 0.5rem;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        border: 1px solid #D1D1D1;
        border-radius: 0.5rem;

        &::placeholder {
            color: #adadad !important;
        }
    }

    .textarea:focus {
        color: #3B334A;
        background-color: #fff;
        border-color: #d1d1d1;
        outline: 0;
        box-shadow: 0 0 0 0.2rem rgba(44, 235, 169, 0.25);
    }

</style>